<template>
  <div id="admin-customer-list">
    <div class="row">
      <div class="col-12 mb-1">
        <h4 class="text-blue"><b><u>User Management List</u></b></h4>
      </div>
      <div class="col-12 mb-3">
        <b-form inline @submit.stop.prevent="search">
          <label class="mr-2 mb-2" for="inline-form-custom-select-pref">Email:</label>
          <b-form-input type="email" class="mr-2 mb-2" v-model="form.email"></b-form-input>
          <label class="mr-2 mb-2" for="inline-form-custom-select-pref">First Name:</label>
          <b-form-input type="text" class="mr-2 mb-2" v-model="form.firstName"></b-form-input>
          <label class="mr-2 mb-2" for="inline-form-custom-select-pref">Last Name:</label>
          <b-form-input type="text" class="mr-2 mb-2" v-model="form.lastName"></b-form-input>
          <label class="mr-2 mb-2" for="inline-form-custom-select-pref">Company:</label>
          <b-form-input type="text" class="mr-2" v-model="form.company"></b-form-input>
          <b-button type="submit" variant="primary"><i class="fas fa-search"></i> Search</b-button>
        </b-form>
      </div>
      <div class="col-12">
        <div class="overflow-auto">
          <b-table bordered hover id="customer-table" :fields="fields" :items="items" :per-page="perPage"
            :current-page="currentPage" small show-empty>
            <template v-slot:cell(index)="data">
              <div class="text-center">{{ data.index + 1 }}</div>
            </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
                <router-link :to="'/agentclound-management/user-list/edit/' + data.item.email"><i
                    class="far fa-edit"></i></router-link>
                <i class="far fa-trash-alt ml-2 cursor-pointer" @click="confirmDeleteUser(data.item.userID)"></i>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="col-12 text-right">
        <div class="float-right">
          <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage"
            aria-controls="customer-table">
          </b-pagination>
        </div>
      </div>
    </div>

    <b-modal id="modal-confirm" centered>
      <template v-slot:modal-header="{ close }">
        <h2 class="text-right w-100 mb-0">
          <img src="./../../../../assets/images/icon/close.png" @click="close()" class="cursor-pointer" width="25">
        </h2>
      </template>
      <template v-slot:default>
        <div class="text-center">
          <h4><b>Are you sure?</b></h4>
          <div class="pt-4 px-5">
            <div class="text-center">
              <button class="btn btn-outline-secondary mb-3 mr-2" @click="$bvModal.hide('modal-confirm')"><b>Cancel</b></button>
              <button class="btn btn-danger mb-3" @click="deleteUser()"><b>OK</b></button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        fields: [{
            key: 'index',
            label: 'No.'
          },
          {
            key: 'firstName',
            label: 'First Name'
          },
          {
            key: 'lastName',
            label: 'Last Name'
          },
          {
            key: 'email',
            label: 'Email'
          },
          {
            key: 'company',
            label: 'Company'
          },
          {
            key: 'role',
            label: 'Role'
          },
          {
            key: 'updateDate',
            label: 'Update Date'
          },
          {
            key: 'action',
            label: 'Action'
          }
        ],
        items: [],
        form: {
          email: '',
          firstName: '',
          lastName: '',
          company: ''
        },
        userID: 0
      }
    },
    mounted() {
      this.search()
    },
    methods: {
      search() {
        const header = {
          'headers': {
            'token': JSON.parse(localStorage.getItem('agenthub-admin')).token
          }
        }
        let loading = this.$loading.show()
        const formData = new FormData
        formData.append('firstName', this.form.firstName)
        formData.append('lastName', this.form.lastName)
        formData.append('email', this.form.email)
        formData.append('company', this.form.company)
        formData.append('pageNo', 1)
        formData.append('pageSize', 999999999)
        formData.append('sortOrder', 'UpdateDate DESC')
        this.$http.post(this.$app.baseURL + this.$path.userSearch, formData, header).then(
          res => {
            loading.hide()
            this.items = res.data.data
          })
      },
      confirmDeleteUser(value) {
        this.userID = value
        this.$bvModal.show('modal-confirm')
      },
      deleteUser() {
        const header = {
          'headers': {
            'token': JSON.parse(localStorage.getItem('agenthub-admin')).token
          }
        }
        let loading = this.$loading.show()
        const formData = new FormData
        formData.append('userID', this.userID)
        this.$http.post(this.$app.baseURL + this.$path.userDelete, formData, header).then(
          res => {
            loading.hide()
            this.$bvModal.hide('modal-confirm')
            if (res.data.data == 200) {
              this.makeToast('Alert', 'Delete successfully', 'success')
              setTimeout(() => {
                this.search()
              }, 200);
            } else {
              this.makeToast('Alert', 'Cannot delete please try again later', 'warning')
            }
          }, () => {
            loading.hide()
            this.makeToast('Alert', 'Cannot delete please try again later', 'warning')
            this.$bvModal.hide('modal-confirm')
          })
      }
    }
  }
</script>

<style scoped>
  label#fromDate {
    border: none;
  }
</style>